import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MuiAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MuiToolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import Logout, { LogoutLabels } from './Logout';

export interface AppBarModule {
  path: string;
  label: string;
}

export interface AppBarLabels {
  title?: string;
  product?: string;
  logout?: LogoutLabels;
}

export interface AppBarProps {
  labels?: AppBarLabels;
  onLogout: () => void;
  onSelect: (event: SelectChangeEvent) => void;
  modules: AppBarModule[];
  currentModulePath?: string;
  Toolbar?: React.ReactNode;
}

const AppBar: React.FC<AppBarProps> = ({ labels = {}, onLogout, onSelect, modules, currentModulePath, Toolbar }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <MuiAppBar>
      <MuiToolbar>
        <Typography variant="body1" component="div" sx={{ ml: 0, mr: 2, fontSize: 20 }}>
          {labels.title || 'GridOS'}
        </Typography>
        {labels.product && (
          <Typography variant="body1" component="div" sx={{ ml: 0, mr: 2, fontSize: 20 }}>
            {labels.product}
          </Typography>
        )}
        {modules.length > 1 ? (
          <Select
            id="nav-bar-select"
            variant="outlined"
            value={currentModulePath}
            onChange={onSelect}
            sx={{
              ml: 3,
              minWidth: 200,
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 },
              color: 'text.labelwhite',
            }}
          >
            {modules.map(({ path, label }) => (
              <MenuItem key={path} value={path}>
                {label}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <Typography variant="body1" sx={{ margin: 0, fontSize: '20px', fontWeight: 400 }}>
            {modules[0]?.label}
          </Typography>
        )}
        <Box sx={{ flexGrow: 3 }} />
        {Toolbar}
        <Box sx={{ ml: 1, mr: 1, width: 0, borderLeft: '1px solid', borderColor: 'borders.moderate', height: 50 }} />
        <IconButton onClick={handleClick} color="inherit">
          <MoreHorizIcon />
        </IconButton>
      </MuiToolbar>
      <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
        <Logout labels={labels.logout} logout={onLogout} />
      </Menu>
    </MuiAppBar>
  );
};

export default AppBar;
